/**
 * Document Type Configuration
 * Defines MIME types, icons, and display settings for different document types
 */

export const DOCUMENT_TYPES = {
  tiff: {
    mimeTypes: ['data:image/tiff', 'data:image/tif'],
    icon: '🖼️',
    bgColor: '#E8F5E9',
    label: 'TIFF Image',
    renderPreview: true,
    requiresSpecialHandling: true,
  },
  image: {
    mimeTypes: ['data:image/'],
    icon: '🖼️',
    bgColor: '#E8F5E9',
    label: 'Image',
    renderPreview: true,
  },
  pdf: {
    mimeTypes: ['data:application/pdf'],
    icon: '📑',
    bgColor: '#FFEBEE',
    label: 'PDF Document',
    renderPreview: false,
  },
  word: {
    mimeTypes: [
      'data:application/msword',
      'data:application/vnd.openxmlformats-officedocument.wordprocessingml',
    ],
    icon: '📄',
    bgColor: '#E3F2FD',
    label: 'Word Document',
    renderPreview: false,
  },
  excel: {
    mimeTypes: [
      'data:application/vnd.ms-excel',
      'data:application/vnd.openxmlformats-officedocument.spreadsheetml',
    ],
    icon: '📊',
    bgColor: '#E8F5E9',
    label: 'Excel Spreadsheet',
    renderPreview: false,
  },
  powerpoint: {
    mimeTypes: [
      'data:application/vnd.ms-powerpoint',
      'data:application/vnd.openxmlformats-officedocument.presentationml',
    ],
    icon: '📽️',
    bgColor: '#FFF3E0',
    label: 'PowerPoint',
    renderPreview: false,
  },
  text: {
    mimeTypes: ['data:text/'],
    icon: '📝',
    bgColor: '#F3E5F5',
    label: 'Text Document',
    renderPreview: false,
  },
  unknown: {
    mimeTypes: ['data:'],
    icon: '📎',
    bgColor: '#ECEFF1',
    label: 'Document',
    renderPreview: false,
  },
};

/**
 * Detect document type from data URI
 * @param {string} value - The data URI string
 * @returns {string} - The document type key
 */
export const getDocumentType = (value) => {
  if (typeof value !== 'string') return 'unknown';

  for (const [type, config] of Object.entries(DOCUMENT_TYPES)) {
    if (type === 'unknown') continue; // Check unknown last

    const matches = config.mimeTypes.some((mimeType) =>
      value.startsWith(mimeType)
    );

    if (matches) return type;
  }

  return value.startsWith('data:') ? 'unknown' : null;
};

/**
 * Get document configuration by type
 * @param {string} type - The document type
 * @returns {object} - Document configuration
 */
export const getDocumentConfig = (type) => {
  return DOCUMENT_TYPES[type] || DOCUMENT_TYPES.unknown;
};
